import { useI18n } from '@i18n';
import { Badge, Button, Stack, StackProps, useTheme } from '@mui/material';
import React from 'react';
import { ICONS } from '@/assets/icons';
import { useBuildingFilters } from '@/components/building-filters/BuildingFiltersProvider';
import { calculateFilterCount } from '@/components/building-filters/utils';
import Iconify from '@/components/Iconify';

type Props = {
  isOpen: boolean;
  sx?: StackProps['sx'];
  handleOpen: (event: React.MouseEvent<HTMLElement>) => void;
  /** Overrides the button's rendered height — MUI's size prop alone doesn't line this
   * up with other component types (e.g. Button, ToggleButtonGroup) in the same toolbar row. */
  height?: number;
};

const BuildingFiltersMoreButton = ({ isOpen, sx, handleOpen, height = 40 }: Props) => {
  const theme = useTheme();
  const { t } = useI18n();
  const { urlFilters } = useBuildingFilters();

  const filterCount = calculateFilterCount(urlFilters);

  return (
    <Stack direction={'row'} mr={1} gap={1} sx={sx}>
      <Badge badgeContent={filterCount} color="error">
        <Button
          variant="outlined"
          size="medium"
          startIcon={<Iconify icon={ICONS.IC_ROUND_FILTER_LIST} />}
          onClick={handleOpen}
          sx={{
            height,
            borderColor: isOpen ? theme.palette.common.black : theme.palette.divider,
            '&:hover': {
              borderColor: isOpen ? theme.palette.common.black : theme.palette.divider,
            },
          }}
        >
          {t('General_MoreFilters')}
        </Button>
      </Badge>
    </Stack>
  );
};

export default BuildingFiltersMoreButton;
